import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FiPlay, FiPause } from "react-icons/fi";
import "../../styles/Testimonials.css";
import { testimonials } from "../../data/Testimonialsdata";

const VISIBLE = 6;
const AUTO_INTERVAL = 3500;

const STACK_OFFSETS = [
  { x: 0, y: 0 },
  { x: 14, y: -12 },
  { x: 28, y: -24 },
  { x: 42, y: -36 },
  { x: 56, y: -48 },
  { x: 70, y: -60 },
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  // Autoplay
  useEffect(() => {
    if (paused) return;

    const id = setInterval(() => {
      nextCard();
    }, AUTO_INTERVAL);

    return () => clearInterval(id);
  }, [paused]);

  const nextCard = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const visibleCards = testimonials.slice(index, index + VISIBLE);

  return (
    <div className="testimonial-cards-section">
      <h1 className="testimonial-section-title text-secondary">
        Hear It From Our Clients
      </h1>
      <div className="testimonial-cards-stack-content-wrapper">
        {/* play / pause  */}
        <button
          aria-label={paused ? "Play animation" : "Pause animation"}
          className="testimonial-cards-stack-content-change"
          onClick={() => setPaused((p) => !p)}
        >
          {paused ? <FiPlay size={18} /> : <FiPause size={18} />}
        </button>

        <div className="testimonial-cards-stack-content-list">
          <AnimatePresence>
            {visibleCards.map((card, i) => (
              <motion.div
                key={card.id}
                className="testimonial-cards-stack-content-square"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: 1,
                  x: STACK_OFFSETS[i]?.x ?? 0,
                  y: STACK_OFFSETS[i]?.y ?? 0,
                  scale: 1 - i * 0.015,
                  zIndex: VISIBLE - i,
                }}
                exit={{
                  opacity: 0,
                  x: 90,
                  y: 180,
                  rotate: -8,
                  scale: 0.95,
                }}
                transition={{
                  duration: 0.5,
                  ease: "easeInOut",
                }}
              >
                <div className="testimonial-cards-stack-content-square-item glue-text-center">
                  <p className="testimonial-cards-stack-content-square-eyebrow">
                    {card.title}
                  </p>

                  <p className="testimonial-cards-stack-content-square-quote">
                    {card.text}
                  </p>

                  <div className="testimonial-author-block">
                    <img
                      src={card.avatar}
                      alt={card.author}
                      className="testimonial-avatar"
                    />
                    <div>
                      <p className="testimonial-author">{card.author}</p>
                      <p className="testimonial-role">{card.role}</p>
                    </div>
                  </div>

                  {card.cta && (
                    <a
                      href={card.cta.url}
                      className="testimonial-cards-stack-content-square-cta"
                    >
                      <span>{card.cta.text}</span>
                    </a>
                  )}
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
